module.exports = __webpack_public_path__ + "static/media/recommend1.002f752d.png";